exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td[data-v-72f349cc],th[data-v-72f349cc]{width:120px}", ""]);

// exports
